module.exports = __webpack_public_path__ + "static/img/logo.f6fee85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 77
// module chunks = 1